import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/*
    曝光埋点发送规则
    1. 已上报的metric缓存起来，不再上报
    2. 精简模式下，页面不再有新元素1.5秒后发送一次，并且发送本次全部埋点中，最后一个
*/

import { unique, late, inviewport, getPageIdInfo, debounce } from "../utils/common";
import calculateScore from "../utils/calculateScore";
import calculateMaxMetric from "../utils/calculateMaxMetric";
import lego from "../lego";
var METRIC_ATTR_NAME = 'data-metric';
var isServer = typeof window === 'undefined';
var height = isServer ? 0 : window.innerHeight;
var width = isServer ? 0 : window.innerWidth;
var targetArr = [];
var params = {}; // 埋点参数
var options = {}; // 传入的配置信息
var observer = null; // 监听器对象
var delayTime = 1500; // 默认的debounce时间，用户停留1.5秒后，上报此次埋点
var hasExposure = []; // 已曝光的metric
var scoreList = {}; // 带有data-metric的节点深度信息
var cacheMetric = []; // 待上报的metric集合
var pageIdInfo = {}; // 页面信息
var extraInfo = '{}'; // 是否有角标，在区域曝光中使用
var cacheCallback = function cacheCallback() {};

// 常规模式发送乐高埋点
var sendLegoLog = function sendLegoLog(metric) {
  legoLog(metric);
};

// 精简模式发送乐高埋点
var sendThriftLegoLog = debounce(function () {
  var resultMetric = calculateMaxMetric(cacheMetric, scoreList);
  cacheMetric = []; // 待上报的metric清空

  resultMetric.forEach(function (item) {
    legoLog(item.actual);
    hasExposure = unique(hasExposure.concat(item.relevant));
  });
}, delayTime);

// 发送埋点的逻辑
var legoLog = function legoLog(metric) {
  var _pageIdInfo;
  // 已经曝光的不再上报
  if (hasExposure.indexOf(metric) !== -1) {
    return;
  }
  hasExposure.push(metric);
  params.pagetype = 'METRIC';
  params.actiontype = (_pageIdInfo = pageIdInfo) === null || _pageIdInfo === void 0 ? void 0 : _pageIdInfo.pageId;
  if (!params.actiontype) {
    console.error('请配置pageId');
    return;
  }
  params.backup = Object.assign({}, _objectSpread({
    metric: metric,
    sectionId: params.sectionId
  }, JSON.parse(extraInfo)));
  lego.send(params, cacheCallback);
};

// IntersectionObserver方法的处理逻辑
var ISObserver = function ISObserver() {
  observer = new IntersectionObserver(observerLogic, {
    threshold: 0.5 // 元素50%显示时，即认为出现在了可视区
  });

  targetArr.forEach(function (item) {
    return observer.observe(item);
  });
};

// 元素出现在可视区的操作逻辑
var observerLogic = function observerLogic(entries) {
  var maxMetric = '';
  entries.forEach(function (entry) {
    // 可见元素的可见比例大于0
    if (entry.intersectionRatio && entry.intersectionRatio > 0) {
      maxMetric = entry.target.getAttribute(METRIC_ATTR_NAME);
      extraInfo = entry.target.getAttribute('data-info') || entry.target.parentElement.getAttribute('data-info') || '{}';
      if (maxMetric) {
        if (options.isThrift) {
          cacheMetric.push(maxMetric);
          sendThriftLegoLog();
        } else {
          sendLegoLog(maxMetric);
        }
      }
    }
  });
};

// inviewport判断取可视区的最大值
var ExposureCollector = function ExposureCollector() {
  var maxMetric = '';
  for (var i = 0; i < targetArr.length; i++) {
    if (inviewport(targetArr[i], height, width)) {
      maxMetric = targetArr[i].getAttribute(METRIC_ATTR_NAME);
      if (maxMetric) sendLegoLog(maxMetric);
    }
  }
};

// 首次商品曝光
var act = late(ExposureCollector);

// 监听页面滚动上报
var exposureDefault = function () {
  var initFlag = false;
  return function () {
    // 判断上下滚动
    var startScrollTop = 0;
    if (initFlag) return;
    initFlag = true;
    window.addEventListener('scroll', function (e) {
      e.stopPropagation();
      var nextScrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
      // 下滚动才发埋点
      if (nextScrollTop - startScrollTop > 0) {
        try {
          act({});
        } catch (err) {}
      }
      startScrollTop = nextScrollTop;
    }, false);
  };
}();

// 导出调用函数
var zpmExposure = function zpmExposure(legoParams, opts, callback) {
  try {
    params = legoParams || {};
    options = Object.assign({}, options, opts, {
      isThrift: true
    });
    cacheCallback = callback ? callback : cacheCallback;
    if (!isServer) {
      // 严格模式下，计算所有节点深度，并存储
      if (options.isThrift) {
        scoreList = calculateScore(METRIC_ATTR_NAME);
      }
      targetArr = document.querySelectorAll("[".concat(METRIC_ATTR_NAME, "]"));
      height = window.innerHeight;
      width = window.innerWidth;
      pageIdInfo = getPageIdInfo();

      // 判断是否支持IntersectionObserver属性来决定监听元素进入可视区的方法
      if (window.IntersectionObserver) {
        // 先断开再监听，避免重复监听情况
        if (observer) observer.disconnect();
        ISObserver();
      } else {
        act({});

        // 通过scroll事件监听
        exposureDefault();
      }
    }
  } catch (err) {}
};
export default zpmExposure;